class ZoomImage extends HTMLElement {
  constructor() {
    super();

    this.imageElement = this.querySelector("img");
    this.aspectRatio = parseFloat(this.dataset.aspectRatio);
  }

  getDimensions() {
    return {
      width: this.clientWidth,
      height: Math.min(this.clientHeight, this.clientWidth / this.aspectRatio),
    };
  }

  setupZoom() {
    if (this.wzoom) {
      return;
    }

    const dimensions = this.getDimensions();
    this.wzoom = WZoom.create(this.imageElement, {
      speed: 10,
      width: dimensions.width,
      height: dimensions.height,
      minScale: 1,
      maxScale: 3,
      smoothTime: 0,
    });

    this.imageElement.addEventListener("touchstart", (event) => {
      if (event.targetTouches.length === 2) {
        event.preventDefault(); // Override pinch-to-zoom on image
      }
    });

    window.addEventListener(
      "resize",
      debounce(this.updateDimensions.bind(this), 200)
    );
  }

  updateDimensions() {
    if (!this.wzoom) {
      return;
    }
    const dimensions = this.getDimensions();
    this.wzoom.options.width = dimensions.width;
    this.wzoom.options.height = dimensions.height;
    this.wzoom.prepare();
  }

  show() {
    this.classList.add("is-selected");
    this.visible = true;
    this.activate();
  }

  hide() {
    this.classList.remove("is-selected");
    this.visible = false;
  }

  activate() {
    if (this.wzoom) {
      this.updateDimensions();
      this.wzoom.transform(0, 0, 1);
      return;
    }

    const isLoaded =
      this.imageElement.complete && this.imageElement.naturalHeight !== 0;

    if (isLoaded) {
      this.setupZoom();
    } else {
      const handleImageLoad = () => {
        this.imageElement.removeEventListener("load", handleImageLoad);
        this.setupZoom();
      };
      this.imageElement.addEventListener("load", handleImageLoad);
    }
  }

  handleTouchStart(event) {
    if (event.touches.length === 2) {
      event.preventDefault(); // Override pinch-to-zoom on image
    }
  }
}
customElements.define("zoom-image", ZoomImage);
